import React from 'react';
import type { CapiNewsArticle, Tag as TagType } from 'types/capi/newsArticle';

import useEnv from '~/hooks/useEnv';

const Tags = ({ tags }: { tags: CapiNewsArticle['tags'] }) => {
  return (
    <div className="flex flex-wrap items-center justify-start gap-x-2 text-grey-divide">
      {tags.map((tag, index) => (
        <React.Fragment key={`news-tag-${index}`}>
          <Tag key={index} tag={tag} />
          {tags.length - 1 > index && <span className="mb-1 text-xl">•</span>}
        </React.Fragment>
      ))}
    </div>
  );
};

const Tag = ({ tag }: { tag: TagType }) => {
  const env = useEnv();

  return (
    <a className="hover:underline" href={`${env.SITE_BASE_URL}${tag.path}`}>
      {tag.label}
    </a>
  );
};

export default Tags;
